import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Background from '../../../domain/entities/Background';

export default function reducer(
  state: {[key: number]: Background} = {},
  action: AnyAction,
): {[key: number]: Background} {
  switch (action.type) {
    case Types.IndexBackgroundsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Background}, record: Background) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowBackgroundSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
